// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from Textarea-Hint.module.scss  */
.Textarea-Hint-module-Root_1in {
  margin-top: 8px;
  font-family: var(--textarea-font-family);
  font-size: var(--textarea-hint-fz);
  line-height: 1.43;
  color: var(--textarea-hint-color);
  animation: Textarea-Hint-module-Hint_show_2se 100ms ease-in forwards; }

.Textarea-Hint-module-Root_1in.Textarea-Hint-module-leave_L1e {
  animation: Textarea-Hint-module-Hint_leave_1dv 100ms ease-out forwards; }

@keyframes Textarea-Hint-module-Hint_leave_1dv {
  to {
    opacity: 0;
    transform: translateY(-6px); }
  from {
    opacity: 1;
    transform: translateY(0); } }

@keyframes Textarea-Hint-module-Hint_show_2se {
  from {
    opacity: 0;
    transform: translateY(-6px); }
  to {
    opacity: 1;
    transform: translateY(0); } }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Textarea/Hint/Textarea-Hint.css"],"names":[],"mappings":"AAAA,8CAA8C;AAC9C;EACE,eAAe;EACf,wCAAwC;EACxC,kCAAkC;EAClC,iBAAiB;EACjB,iCAAiC;EACjC,oEAAoE,EAAE;;AAExE;EACE,sEAAsE,EAAE;;AAE1E;EACE;IACE,UAAU;IACV,2BAA2B,EAAE;EAC/B;IACE,UAAU;IACV,wBAAwB,EAAE,EAAE;;AAEhC;EACE;IACE,UAAU;IACV,2BAA2B,EAAE;EAC/B;IACE,UAAU;IACV,wBAAwB,EAAE,EAAE","sourcesContent":["/*  imported from Textarea-Hint.module.scss  */\n.Textarea-Hint-module-Root_1in {\n  margin-top: 8px;\n  font-family: var(--textarea-font-family);\n  font-size: var(--textarea-hint-fz);\n  line-height: 1.43;\n  color: var(--textarea-hint-color);\n  animation: Textarea-Hint-module-Hint_show_2se 100ms ease-in forwards; }\n\n.Textarea-Hint-module-Root_1in.Textarea-Hint-module-leave_L1e {\n  animation: Textarea-Hint-module-Hint_leave_1dv 100ms ease-out forwards; }\n\n@keyframes Textarea-Hint-module-Hint_leave_1dv {\n  to {\n    opacity: 0;\n    transform: translateY(-6px); }\n  from {\n    opacity: 1;\n    transform: translateY(0); } }\n\n@keyframes Textarea-Hint-module-Hint_show_2se {\n  from {\n    opacity: 0;\n    transform: translateY(-6px); }\n  to {\n    opacity: 1;\n    transform: translateY(0); } }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
